import { AxiosResponse } from 'axios';
import { LoanControllerApi, SimulationResponseDto } from 'client';
import { getTokenFromStorage } from 'utils/GetTokenFromStorage';

export const useSimulationServices = () => {
	const services = new LoanControllerApi();

	const getSimulation = async (simulation: any): Promise<AxiosResponse<SimulationResponseDto>> => {
		return services.getLoanSimulationUsingGET(
			getTokenFromStorage(),
			simulation.downPayment,
			'NO',
			simulation.installmentNumber,
			123123,
			'CF',
			true,
			true,
			simulation.vehicleValue,
			simulation.vehicleYear,
		);

	};

	return { getSimulation } as const;
};
